function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, memo, useCallback, useState } from 'react';
import classname from 'classnames';
import { attachPropertiesToComponent as attach } from 'antd-mobile/es/utils/attach-properties-to-component';
import "./index.scss";
import TextArea from "./TextArea";
const InputField = /*#__PURE__*/memo(({
  className,
  value,
  placeholder,
  label,
  maxLength,
  filter,
  focus = '',
  disabled,
  placeHolderStyle,
  onChange,
  onClick,
  onBlur,
  ...others
}) => {
  const [val, setValue] = useState('');
  const [focused, setFocused] = useState(focus);
  useEffect(() => {
    setValue(value || '');
  }, [value]);
  useEffect(() => {
    setFocused(focus);
  }, [focus]);
  const onFieldChange = useCallback(e => {
    let newVal = filter ? e.target.value.replace(filter, '') : e.target.value;
    if (maxLength) {
      newVal = newVal.slice(0, maxLength);
    }
    setValue(newVal);
    onChange?.(newVal, e);
  }, [onChange, maxLength]);
  const onInputBlur = useCallback(e => {
    setFocused(false);
    onBlur?.(e, val);
  }, [val, onBlur]);
  const clear = useCallback(() => {
    setValue('');
    onChange?.('');
  }, [onChange]);
  const wxAttrs = IS_MP ? {
    focus: String(focused),
    maxlength: maxLength,
    'placeholder-style': placeHolderStyle || 'color: rgb(173, 177, 196); font-weight: normal;',
    'kbone-attribute-map': JSON.stringify({
      disabled
    }),
    // true/false值无法在kbone传递
    ...others
  } : {
    disabled,
    maxLength,
    ...others
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classname('cc-input fieldLine', className, {
      disabled
    })
  }, label ? /*#__PURE__*/React.createElement("div", {
    className: "fieldLabel"
  }, label) : null, /*#__PURE__*/React.createElement("div", {
    className: "fieldInput"
  }, /*#__PURE__*/React.createElement("input", _extends({}, wxAttrs, {
    type: "text"
    // 小程序环境中, input focus 时, input 样式中的 font-weight 会覆盖掉 placeholder-style 的, 所以在让加粗仅在有文字时生效
    ,
    className: classname('inputField', {
      bold: val.length > 0
    }),
    onChange: onFieldChange,
    onClick: onClick,
    value: val,
    onFocus: () => setFocused(true),
    onBlur: onInputBlur,
    autoFocus: isTrue(focused)
    // 填写 placeholder 会导致小程序输入框输入文字后重影
    ,
    placeholder: val.length ? '' : placeholder || `请输入${label ?? ''}`
  }))), /*#__PURE__*/React.createElement("div", {
    className: classname('iconfont icon-guanbi clear', {
      show: val.length && focused
    }),
    onClick: clear
  }));
});
const isTrue = v => v === true || v === 'true';
InputField.displayName = 'cc-input';
export default attach(InputField, {
  TextArea
});
export const filterReg = {
  /** 过滤Unicode字母 数字 Unicode字符符号 分隔符 换行 */
  unicode: /[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gi
};